import React from 'react';
import { Tooltip } from '@mui/material';
import { Button } from '../../../../Components/MUIs';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GridCheckBox from '../../../../Components/Ui/GridCheckBox/GridCheckBox';
import CustomHeader from '../../../../Components/AgGrid/CustomHeader';
import MultiLineEditor from '../../../../Components/MultiLineEditor/MultiLineEditor';
import { CreateColumn } from '../../../../Services/agGrid/createColumn';
/**
 * RIS_BASIC_01 컬럼 정의
 * 위험성평가(RIS_BASIC_01) 모듈의 그리드 컬럼 정의
 * 관심사 분리를 위한 MEM_BASIC 패턴을 따름
 *
 * 참고: 일부 셀 렌더러는 복잡한 비즈니스 로직을 포함하고 있어
 * 별도의 핸들러 함수나 커스텀 컴포넌트로 추출하는 것이 좋습니다.
 */

/**
 * 그리드 1: 기본 위험성평가 목록 그리드
 * 기본 위험성평가 목록 그리드
 *
 * 참고: 이 파일은 원래의 단일 컴포넌트에서 추출되었습니다.
 * 복잡한 로직을 가진 셀 렌더러(예: rsNm 컬럼)는
 * 유지보수성을 위해 별도의 핸들러 함수로 리팩토링하는 것이 좋습니다.
 */
export const getColumnDefs1 = (props) => [
  CreateColumn('no', 'NO', 'left', 100, false, false, false, 'checkbox', {
    checkboxProps: {
      DeleteNewRow1: props.DeleteNewRow1,
      RestoreRow1: props.RestoreRow1,
      gridRef1: props.gridRef1,
      rowData1: props.rowData1,
      selectedRowNosRef: props.selectedRowNosRef1,
      lastCheckedIndexRef: props.lastCheckedIndexRef1,
      handleRowSelection: props.handleRowSelection1,
    },
    maxWidth: 100,
  }),
  // 위험성평가명 (필수, 편집불가, 버튼 타입)
  CreateColumn(
    'rsNm',
    '위험성평가명',
    'left',
    200,
    true,
    true,
    false,
    'requiredButton',
    {
      buttonClickHandler: async (params) => {
        const row = params?.data;
        if (!row) return;
        if (props.onOpenRegulation) {
          props.onOpenRegulation(row);
          return;
        }
        if (props.SearchLogic2) {
          await props.SearchLogic2(row, { shouldSetRsCd: true });
        }
      },
      buttonEmptyTooltip: '위험성평가 설정은 필수입니다.',
      buttonValueTooltip: '재설정 시 클릭하세요.',
    }
  ),
  // 평가구분
  CreateColumn(
    'rsGubun',
    '평가구분',
    'left',
    200,
    false,
    false,
    false,
    'text',
    {
      cellClass: 'none-editable-cell',
    }
  ),
  // 평가방법
  CreateColumn(
    'rsMethod',
    '평가방법',
    'left',
    200,
    false,
    false,
    false,
    'text',
    {
      cellClass: 'none-editable-cell',
    }
  ),
  CreateColumn('depNm', '부서', 'left', 200, false, false, false, 'text', {
    tooltip: '위험성평가명을 클릭하면 수정할 수 있습니다.',
    flex: 1,
    cellClass: 'none-editable-cell',
  }),
    CreateColumn(
      'rsStartDate',
      '평가 시작일',
      'center',
      200,
      false,
      false,
      false,
      'date',
      {
        cellClass: 'none-editable-cell',
      }
    ),
    CreateColumn(
      'rsEndDate',
      '평가 종료일',
      'center',
      200,
      false,
      false,
      false,
      'date',
      {
        cellClass: 'none-editable-cell',
      }
    ),
  CreateColumn('rsMember', '평가자', 'left', 200, false, false, false, 'text', {
    cellClass: 'none-editable-cell',
  }),
  // 위험성평가 실시 (RIS_BASIC_01과 동일 패턴)
  CreateColumn(
    '',
    '위험성평가 실시',
    'center',
    150,
    false,
    false,
    false,
    'button',
    {
      buttonText: '이동',
      buttonClickHandler: async (params) => {
        const rowData = params.data;
        if (!rowData) {
          if (props.dispatchGrid && props.showSnackbar) {
            props.dispatchGrid(
              props.showSnackbar({
                message: '항목을 선택하세요.',
                type: 'warning',
              })
            );
          }
          return;
        }

        // 해당 행을 선택된 행으로 설정
        if (props.setSelectedRowData1 && props.handleRowSelection1) {
          props.handleRowSelection1([rowData]);
          props.setSelectedRowData1([rowData]);
        }

        // 1) 커스텀 핸들러가 있으면 우선 사용
        if (props.onExecuteRiskAssessment) {
          await props.onExecuteRiskAssessment(rowData);
          return;
        }

        // 2) 기존 RIS_BASIC_01 방식(openModal/Search6) 호환
        if (props.openModal) {
          props.openModal('riskAssessment3Level');
          props.Search6?.({ rsCd: rowData.rsCd });
        }
      },
      pinned: 'right',
    }
  ),
];
export const getColumnDefs2 = (props) => [
  CreateColumn('no', 'NO', 'left', 100, false, false, false, 'checkbox', {
    checkboxProps: {
      DeleteNewRow1: null,
      RestoreRow1: null,
      gridRef1: props.gridRef6,
      rowData1: props.modalRowData6,
      selectedRowNosRef: props.selectedRowNosRef2,
      lastCheckedIndexRef: props.lastCheckedIndexRef2,
      handleRowSelection: props.handleRowSelection2,
    },
    maxWidth: 100,
  }),
  CreateColumn(
    'rsNm',
    '위험성평가명',
    'left',
    200,
    false,
    false,
    false,
    'text',
    {
      cellClass: 'none-editable-cell',
    }
  ),
  // 평가구분
  CreateColumn(
    'rsGubun',
    '평가구분',
    'left',
    200,
    false,
    false,
    false,
    'text',
    {
      cellClass: 'none-editable-cell',
    }
  ),
  // 평가방법
  CreateColumn(
    'rsMethod',
    '평가방법',
    'left',
    200,
    false,
    false,
    false,
    'text',
    {
      cellClass: 'none-editable-cell',
    }
  ),
  CreateColumn('depNm', '부서', 'left', 200, false, false, false, 'text', {
    flex: 1,
    cellClass: 'none-editable-cell',
  }),
  CreateColumn(
    'rsDate',
    '평가일시',
    'center',
    200,
    false,
    false,
    false,
    'date',
    {
      cellClass: 'none-editable-cell',
    }
  ),
  CreateColumn('rsMember', '평가자', 'left', 200, false, false, false, 'text', {
    cellClass: 'none-editable-cell',
  }),
];
export const getColumnDefs3 = (props) => [
  CreateColumn('no', 'NO', 'left', 100, false, false, false, 'checkbox', {
    checkboxProps: {
      DeleteNewRow1: null,
      RestoreRow1: null,
      gridRef1: props.gridRef5,
      rowData1: props.modalRowData4,
      selectedRowNosRef: props.selectedModalRowNosRef4,
      lastCheckedIndexRef: props.lastCheckedIndexRef3,
      handleRowSelection: props.handleRowSelection3,
    },
    maxWidth: 100,
  }),
  CreateColumn('depNm', '부서명', 'left', 200, false, false, false, 'text', {
    cellClass: 'none-editable-cell',
  }),
  // 평가구분
  CreateColumn(
    'categoryComment',
    '위험발생 상황 및 결과',
    'left',
    700,
    false,
    false,
    false,
    'text',
    {
      cellClass: 'none-editable-cell',
    }
  ),
  // 평가방법
  CreateColumn(
    'condolenceNo',
    '조문번호',
    'left',
    120,
    false,
    false,
    false,
    'text',
    {
      cellClass: 'none-editable-cell',
    }
  ),
  CreateColumn(
    'relatedEvidence',
    '관려근거(법적기준)',
    'left',
    300,
    false,
    false,
    false,
    'text',
    {
      flex: 1,
      cellClass: 'none-editable-cell',
    }
  ),
];
/**
 * 모든 컬럼 정의 내보내기
 */
export default {
  getColumnDefs1,
};
